module.exports = __webpack_public_path__ + "static/media/snapchat.83d29b75.svg";